module.exports = __webpack_public_path__ + "static/media/skintype_full.1c555bae.svg";